/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Score_Set_By_OrganizerInputs */



/**
* | output |
* | --- |
* | "Score has been set by organiser" |
*
* @param {Err_Tournament_Score_Set_By_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_score_set_by_organizer = /** @type {((inputs?: Err_Tournament_Score_Set_By_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Score_Set_By_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le score a été saisi par l'organisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("La puntuación ha sido establecida por el organizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A pontuação foi definida pelo organizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il punteggio è stato impostato dall'organizzatore")
	return /** @type {LocalizedString} */ ("Score has been set by organiser")
});